jQuery(function ($) {
	$(document).ready(function () {
		// Mobile menu behaviours
		$('.mob-btn').click(function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$('.holder-nav').toggleClass('active');
		});

		if ($(window).width() < 1024) {
			$('.sub-nav-link svg').click(function (e) {
				e.preventDefault();
				$(this).closest('.sub-nav-link').next('.sub-top-nav').show();
			});
		}

		$('.back-link').click(function (e) {
			e.preventDefault();
			$(this).parents('.sub-top-nav').hide();
		});

		// Menu for my account
		$('.woocommerce-MyAccount-navigation ul li.is-active').on('click', function (e) {
			if ($(window).width() < 1024) {
				$(this).parent().toggleClass('open-menu')
			}
		});

		// Product add to cart plus quantity
		$(document.body).on('click', '.quantity-plus', function (e) {
			e.preventDefault();
			let input = $(this).siblings('.qty');
			let currentValue = parseInt(input.val());
			let max = parseInt(input.attr('max'));
			// if (!max || currentValue < max) {
			input.val(currentValue + 1).trigger('change');
			// }
		});

		// Product add to cart minus quantity
		$(document.body).on('click', '.quantity-minus', function (e) {
			e.preventDefault();
			let input = $(this).siblings('.qty');
			let currentValue = parseInt(input.val()) || 1;
			let min = parseInt(input.attr('min')) || 1;

			if (currentValue > min) {
				input.val(currentValue - 1).trigger('change');
			}
		});
		// Product gallery thumbnails slider
		if ($('.flex-control-nav').length) {
			$('.flex-control-nav').slick({
				dots: false,
				infinite: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				arrows: true,
				// responsive: [
				// 	{
				// 		breakpoint: 640,
				// 		settings: {
				// 			slidesToShow: 6,
				// 		}
				// 	},
				// 	{
				// 		breakpoint: 1024,
				// 		settings: {
				// 			slidesToShow: 5,
				// 		}
				// 	}
				// ]
			})
		}

		// Toggle login/register forms
		$('.link-login').click(function (e) {
			e.preventDefault();
			$(this).parents('.page-login__register').hide();
			$('.page-login__login').show();
			$('.woocommerce-notices-wrapper').empty();
		});
		$('.link-register').click(function (e) {
			e.preventDefault();
			$(this).parents('.page-login__login').hide();
			$('.page-login__register').show();
			$('.woocommerce-notices-wrapper').empty();
		});

		// Apply coupon from custom block
		if ($('.ecom-coupon').length) {
			$(document.body).on('click', '#ecom_coupon_apply', function () {
				const couponValue = $('#ecom_coupon_code').val()
				$('.woocommerce-cart-form #coupon_code').val(couponValue)

				const $form = $('form.woocommerce-cart-form');
				block($form);
				block($('div.cart_totals'));
				const data = {
					security: wc_cart_params.apply_coupon_nonce,
					coupon_code: couponValue,
				};

				$.ajax({
					type: 'POST',
					url: wc_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
					data: data,
					dataType: 'html',
					success: function (response) {
						$(
							'.woocommerce-error, .woocommerce-message, .woocommerce-info, ' +
							'.is-error, .is-info, .is-success, .coupon-error-notice'
						).remove();

						// We only want to show coupon notices if they are not errors.
						// Coupon errors are shown under the input.
						if (response.indexOf('woocommerce-error') === -1 && response.indexOf('is-error') === -1) {
							const $target =
								$('.woocommerce-notices-wrapper:first') ||
								$('.wc-empty-cart-message').closest('.woocommerce') ||
								$('.woocommerce-cart-form');
							$target.prepend(response);

							$(document).trigger('wc_update_cart');
						} else {
							var $coupon_wrapper = $('.ecom-coupon');
							if ($coupon_wrapper.length > 0) {
								var $coupon_error_el = '';
								var msg = $($.parseHTML(response)).text().trim();
								if (msg !== '') {
									$coupon_error_el = $('<p class="coupon-error-notice" id="coupon-error-notice">' + msg + '</p>');
									$coupon_wrapper.addClass('has-error')
									$coupon_wrapper.find('#ecom_coupon_code')
										.attr('aria-invalid', 'true')
										.attr('aria-describedby', 'coupon-error-notice');
									$coupon_wrapper.append($coupon_error_el);
								}
							}
							unblock($form);
							unblock($('div.cart_totals'));
						}

						$(document.body).trigger('applied_coupon', [
							couponValue,
						]);
					},
				});
			});
		}

		// Auto update cart after change qty
		let updateCartTimeout;
		if ($('.woocommerce-cart-form').length) {
			$(document.body).on('change', '.woocommerce-cart-form input.qty', function () {

				if (updateCartTimeout !== undefined) {
					clearTimeout(updateCartTimeout);
				}
				updateCartTimeout = setTimeout(function () {

					$("[name='update_cart']").trigger("click");
				}, 1000);
			});
		}

		/**
		 * Block a node visually for processing.
		 *
		 * @param {JQuery Object} $node
		 */
		var block = function ($node) {
			if (!is_blocked($node)) {
				$node.addClass('processing').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6,
					},
				});
			}
		};

		/**
		 * Unblock a node after processing is complete.
		 *
		 * @param {JQuery Object} $node
		 */
		var unblock = function ($node) {
			$node.removeClass('processing').unblock();
		};

		/**
		 * Check if a node is blocked for processing.
		 *
		 * @param {JQuery Object} $node
		 * @return {bool} True if the DOM Element is UI Blocked, false if not.
		 */
		var is_blocked = function ($node) {
			return (
				$node.is('.processing') || $node.parents('.processing').length
			);
		};

		// Move checkout errors to woocommerce-notices-wrapper
		$(document.body).on('checkout_error', function (event, error_message) {
			$('.woocommerce-NoticeGroup-checkout, .woocommerce-error, .woocommerce-message, .is-error, .is-success').remove();
			$('.woocommerce-notices-wrapper').append(error_message); // eslint-disable-line max-len
		});

		// Change shipping method
		$(document.body).on('change', 'input.shipping_method', function (event) {
			$('#ship-to-different-address-checkbox')[0].checked = false;
			$('#ship-to-different-address-checkbox').trigger('change');
			if ($('input.shipping_method:checked').val() !== undefined && $('input.shipping_method:checked').val().indexOf('parcelmachine_omniva') !== -1) {
				$('#ship-to-different-address').hide()
				$('#wrap_parcelmachine_omniva_field').show()
			} else {
				$('#ship-to-different-address').show()
				$('#wrap_parcelmachine_omniva_field').hide()
			}
		});

		// Move message about coupon was removed to notices wrapper on checkout
		$(document.body).on('removed_coupon_in_checkout', function (event, coupon_code) {
			const $woocommerceMessage = $('form.woocommerce-checkout').prev('.woocommerce-message');
			const $noticesWrapper = $('.woocommerce-notices-wrapper');
			if ($woocommerceMessage.length && $noticesWrapper.length) {
				$noticesWrapper.append($woocommerceMessage)
			}
		});

		// My account order page Actions 
		$('.event-actions').on('click', function (e) {
			e.stopPropagation();
			$('.open-submenu').not($(this).next()).removeClass('open-submenu');
			$(this).next().toggleClass('open-submenu');
		});

		$(document).on('click', function () {
			$('.open-submenu').removeClass('open-submenu');
		});

		$('input.shipping_method').trigger('change');
	});
});
